<template>
    <div>
        <img src="../src/assets/projects/about-new.jpg" style="width: 100%; " />
    </div>
    
    <PeoductIntroduce showItems="['1','3']" :products="products"></PeoductIntroduce>

    <Subscribe></Subscribe>
</template>

<script>
    import Subscribe from '../src/components/Subscribe.vue'
    import PeoductIntroduce from '../src/components/PeoductIntroduce.vue'

    export default {
        name: 'Shop',
        data() {
            return {
                products: [],

            }
        },
        components: {
            Subscribe,
            PeoductIntroduce
        },
        mounted() {
            this.loadData();
        },
        methods: {
            async loadData() {
                try {
                    const response = await fetch('/products.json'); // 注意路径应为相对于public文件夹的路径，或者使用绝对路径如`/data/file.json`
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();

                    this.products = data;

                    for (var i = 0; i < this.products.length; i++) {
                        let num = this.products[i].image;
                        const image = require(`@/assets/projects/${num}.jpg`);
                        this.products[i].image = image;
                    }
                } catch (error) {
                    console.error('There has been a problem with your fetch operation:', error);
                }
            },
        }
    }
</script>

<style scoped>
  
</style>